import { SimulationFormBasic } from './SimulationFormBasic'
import { SimulationFormDelivery } from './SimulationFormDelivery'
import { SimulationFormAdvanced } from './SimulationFormAdvanced'
import { SimulationPlanRepository, translateFormToSimulationPlan } from './'
import Defaults from '@/models/Simulation/Defaults'

export const createFormFactory = async advertiserId => {
  const form = new SimulationPlanForm(advertiserId, {})
  return form
}

export const updateFormFactory = async simulation => {
  const { simulationPlanMenu } = simulation.simulationPlan
  const ownerProfileMenu = (() => {
    if (simulationPlanMenu === undefined) return {}
    return {
      ...simulationPlanMenu,
      id: simulationPlanMenu.id,
    }
  })()
  simulation.simulationPlan.ownerProfileMenu = ownerProfileMenu
  const form = new SimulationPlanForm(null, simulation)
  return form
}

export const readonlyFormFactory = async simulation => {
  const { simulationPlanMenu, creativeType } = simulation.simulationPlan
  simulation.simulationPlan.ownerProfileMenu = {
    id: simulationPlanMenu.originOwnerProfileMenuId,
    name: simulationPlanMenu.menuName,
    creativeType: creativeType,
    menuType: simulationPlanMenu.menuType,
    unitType: simulationPlanMenu.unitType,
    unitPrice: simulationPlanMenu.grossPrice,
    costPlusMarginPercentage: simulationPlanMenu.costPlusMarginPercentage,
  }
  const form = new SimulationPlanForm(null, simulation)
  return form
}

const defaults = Defaults

class SimulationPlanForm {
  constructor(advertiserId = null, simulation = {}) {
    const {
      simulationPlan = {},
      menuSetting = defaults.MenuSetting,
    } = simulation
    if (advertiserId === null) {
      this.basicSetting = new SimulationFormBasic(simulationPlan)
    } else {
      this.basicSetting = new SimulationFormBasic(
        // advetiserIdが渡ってくる場合、simulationPlanとマージする
        Object.assign(simulationPlan, { advertiserId: Number(advertiserId) }),
      )
    }
    this.deliverySetting = new SimulationFormDelivery({
      menuSetting,
    })
    this.advancedSetting = new SimulationFormAdvanced(simulationPlan)
  }

  get isNew() {
    return this.basicSetting.id === null
  }

  get isLocationSettingComplete() {
    return this.deliverySetting.menuSetting.isLocationSettingComplete
  }

  // シミュレーション実行可能か否か
  get isSimulatable() {
    if (!this.basicSetting.isSimulatable) {
      return false
    }
    if (!this.advancedSetting.isSimulatable) {
      return false
    }
    const menuSetting = this.deliverySetting.menuSetting
    return menuSetting.isSimulatable
  }

  get isLegacy() {
    return this.basicSetting.isMenuIdEmpty
  }

  async save() {
    const result = translateFormToSimulationPlan(this)
    return SimulationPlanRepository.create(result)
  }

  async update() {
    const menus = this.basicSetting.menus
    const selectedAgency = this.basicSetting.selectedAgency
    const selectedAdvertiser = this.basicSetting.selectedAdvertiser
    const simulationPoiLocationGroups = this.deliverySetting.menuSetting
      .simulationPoiLocationGroups
    const simulationPlan = translateFormToSimulationPlan(this)
    const updatedSimulationPlan = await SimulationPlanRepository.update(
      this.basicSetting.id,
      simulationPlan,
    )
    const form = await updateFormFactory(updatedSimulationPlan)

    // APIからは帰ってこない値だけ、ここで持たせておく
    form.basicSetting.menus = menus
    form.basicSetting.selectedAdvertiser = selectedAdvertiser
    form.basicSetting.selectedAgency = selectedAgency
    form.deliverySetting.menuSetting.simulationPoiLocationGroups = simulationPoiLocationGroups
    Object.assign(this, form)
  }
}
